// Mock data for Traditional Chinese Medicine Therapist Website

export const therapies = [
  {
    id: 'acupuntura',
    name: 'Acupuntura',
    description: 'Tratamento com agulhas finas que estimula pontos energéticos para aliviar dores e restaurar o equilíbrio interno.',
    benefits: [
      'Alívio de dores crónicas',
      'Redução de stress e ansiedade',
      'Melhoria do sistema imunitário',
      'Equilíbrio energético'
    ],
    image: 'https://images.unsplash.com/photo-1598555763574-dca77e10427e'
  },
  {
    id: 'shiatsu',
    name: 'Shiatsu',
    description: 'Terapia japonesa de pressão que melhora a circulação e relaxa o sistema nervoso.',
    benefits: [
      'Melhoria da circulação sanguínea',
      'Relaxamento profundo',
      'Alívio de tensões musculares',
      'Equilíbrio do sistema nervoso'
    ],
    image: 'https://images.unsplash.com/photo-1519823551278-64ac92734fb1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxtYXNzYWdlJTIwdGhlcmFweXxlbnwwfHx8fDE3NjIwMDA3ODl8MA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 'craniopuntura',
    name: 'Craniopuntura YNSA',
    description: 'Método inovador que atua no cérebro e sistema nervoso central, eficaz em dores crónicas e reabilitação neurológica.',
    benefits: [
      'Tratamento de dores crónicas',
      'Reabilitação neurológica',
      'Melhoria de funções cerebrais',
      'Recuperação pós-AVC'
    ],
    image: 'https://customer-assets.emergentagent.com/job_saude-tradicional/artifacts/s4ff2en8_IMG-20251128-WA0010.jpg'
  },
  {
    id: 'auriculoterapia',
    name: 'Auriculoterapia',
    description: 'Técnica reflexa que atua em pontos específicos da orelha, auxiliando em dores, vícios e distúrbios emocionais.',
    benefits: [
      'Controlo de vícios (tabaco, álcool)',
      'Redução de ansiedade',
      'Alívio de dores',
      'Equilíbrio emocional'
    ],
    image: 'https://customer-assets.emergentagent.com/job_saude-tradicional/artifacts/dcnd6lha_file_00000000b8c07208b94d78a8e6638a21.png'
  },
  {
    id: 'reflexologia',
    name: 'Reflexologia',
    description: 'Massagem terapêutica nos pés que harmoniza órgãos internos e melhora o bem-estar geral.',
    benefits: [
      'Harmonização de órgãos internos',
      'Melhoria da digestão',
      'Redução de stress',
      'Aumento de vitalidade'
    ],
    image: 'https://images.pexels.com/photos/6628700/pexels-photo-6628700.jpeg'
  },
  {
    id: 'tuina',
    name: 'Tui-Na',
    description: 'Massagem terapêutica chinesa que liberta tensões e desbloqueia o fluxo energético.',
    benefits: [
      'Libertação de tensões musculares',
      'Desbloqueio energético',
      'Melhoria da flexibilidade',
      'Alívio de dores articulares'
    ],
    image: 'https://images.unsplash.com/photo-1639162906614-0603b0ae95fd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxtYXNzYWdlJTIwdGhlcmFweXxlbnwwfHx8fDE3NjIwMDA3ODl8MA&ixlib=rb-4.1.0&q=85'
  }
];

export const contactInfo = {
  name: 'Samuel Magalhães',
  title: 'Terapeuta de Medicina Tradicional Chinesa',
  phone: '961 509 484',
  email: 'samuelmagalhaes.mtc@gmail.com',
  locations: ['Porto', 'Braga']
};

export const testimonials = [
  {
    id: 1,
    name: 'Maria S.',
    location: 'Porto',
    text: 'Sofria de dores lombares há anos. Após algumas sessões de acupuntura, sinto-me muito melhor. O Samuel é muito profissional.',
    rating: 5
  },
  {
    id: 2,
    name: 'João P.',
    location: 'Braga',
    text: 'Excelente terapeuta! O shiatsu ajudou-me imenso com o stress e ansiedade. Recomendo vivamente.',
    rating: 5
  },
  {
    id: 3,
    name: 'Ana C.',
    location: 'Porto',
    text: 'A reflexologia melhorou a minha qualidade de sono. Ambiente calmo e acolhedor.',
    rating: 5
  }
];